import React, { useEffect, useState } from "react";
import { Reveal, Eyebrow } from "@/components/ui-bits";
import CertificateViewer from "@/components/CertificateViewer";
import { PageHero } from "@/components/PageShell";
import { api } from "@/lib/api";

export default function CertificateDemo() {
  const [cert, setCert] = useState(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { api.get("/certificate/demo").then((r) => setCert(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHero
        eyebrow="The Certificate"
        title="An interactive Botswana Brilliance Certificate."
        subtitle="Open each stage of the journey to see what is verified, who supplied each record, integrated reports and optional services, in both consumer and industry views."
      />
      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 pb-16">
        {cert && <Reveal><CertificateViewer cert={cert} /></Reveal>}
      </section>

      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 pb-24">
        <div className="grid md:grid-cols-3 gap-6">
          {[
            ["What is verified", "Botswana origin, physical identity and the documented chain of custody, each supported by connected records."],
            ["Who supplied each record", "Every entry shows its independent data, technology or laboratory provider. Not every provider applies to every diamond."],
            ["Live, not static", "The certificate is a living digital record, updated as the diamond moves through manufacturing, grading, ownership and sale."],
          ].map((c, i) => (
            <Reveal key={c[0]} delay={i * 0.1}>
              <div className="glass rounded-2xl p-7 h-full">
                <Eyebrow>{`0${i + 1}`}</Eyebrow>
                <h3 className="mt-4 font-serif text-2xl">{c[0]}</h3>
                <p className="mt-3 text-sm text-bb-silver/65 leading-relaxed">{c[1]}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
